import React , {useState , useEffect} from 'react';
import editIcon from '../../style/images/edit.png';
import {auth, authorization} from "../../Actions";
import {connect , setStore} from 'trim-redux';
import {toNum} from "../../utils";

const Confirmation = ({mobileNum , paymentToken , otpErr}) => {
    const [otp , setOtp] = useState('');
    const [smsCount , setSmsCount] = useState(1);
    const [allowResendCode , setAllowResendCode] = useState(true);
    const [seconds , setSeconds] = useState(100);
    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        }
    });
    // const Completionist = () =><span></span>;
    // const renderer = ({seconds, completed }) => {
    //     if (completed) {
    //         return <Completionist />;
    //     } else {
    //         return  <div className='didnt-get-code'>
    //             <span className='no-code'>ارسال کد پس از: {seconds} ثانیه </span>
    //             <span className='resend-code'></span>
    //             <div className='get-voice-code'></div>
    //         </div>
    //     }
    // };
    function otpHandler(e) {
        if(e.target.value.length === 4){
            authorization(mobileNum , toNum(e.target.value) , paymentToken)
        }
        setOtp(e.target.value)
    }
    function editNum() {
        setStore({
            step: 1
        })
    }
 
    function stopCarret() {
        let obj = document.getElementById('partitioned');
        if (obj.value.length > 5){
            setCaretPosition(obj, 5);
        }
    }
    
    function setCaretPosition(elem, caretPos) {
        if(elem != null) {
            if(elem.createTextRange) {
                let range = elem.createTextRange();
                range.move('character', caretPos);
                range.select();
            }
            else {
                if(elem.selectionStart) {
                    elem.focus();
                    elem.setSelectionRange(caretPos, caretPos);
                }
                else
                    elem.focus();
            }
        }
    }
    function resendCode() {
        setSmsCount(smsCount + 1);
        if(sessionStorage.getItem('smsReq') > 1){
            setAllowResendCode(false);
            setStore({
                showModalErr: true,
                ManySmsReq: true
            });
        }
        else{
            auth(mobileNum , paymentToken , true);
            sessionStorage.setItem("smsReq" , smsCount);
            setSeconds(100);
        }
        
    }
  return (
      <div className='confirmation-wrapper' style={{width: '100%' , marginTop: 25}}>
          <p className='confirmation-code-message'>.کد تایید به شماره موبایل شما پیامک شد</p>
          <div className='user-phone'>
              <div className='user-num'>
                <span>{mobileNum}</span>
              </div>
                 <div className='user-num-edit'>
                     <button onClick={editNum}>
                         ویرایش
                         <img src={editIcon} style={{marginLeft: 5}}/>
                    </button>
                 </div>
          </div>
          <div className='entering-code'>
              <span>.کد تایید 4 رقمی را وارد کنید</span>
          </div>
          <div className='code-input'>
              <div>
                 <input autoComplete="off" className={otpErr ? 'otp-input' : 'otp-input'} type='text' maxLength={4} id='partitioned' onChange={otpHandler} onKeyDown={stopCarret} onKeyUp={stopCarret}/>
              </div>
              <span className={otpErr ? 'errorMsg display-block' : 'display-none'} style={{marginTop: 12 , textAlign: "center"}}>کد تایید وارد شده نادرست است</span>
              </div>
          <div>
    
    
              {
                  
                  allowResendCode ?
                  seconds > 0 ?
                      (<div className='didnt-get-code'>
                          <span className='no-code'> ارسال کد پس از: {seconds} ثانیه </span>
                      </div>) :   <div className='didnt-get-code'>
                          <div style={{display: "flex" , flexDirection: "row-reverse"}}>
                              <span className='no-code'>پیامکی دریافت نکردید؟</span>
                              <span className='resend-code' onClick={resendCode}>ارسال مجدد پیامک فعالسازی</span>
                          </div>
                          {/*<div className='get-voice-code'>*/}
                          {/*<button>*/}
                          {/*دریافت کد فعالسازی از طریق تماس صوتی*/}
                          {/*</button>*/}
                          {/*</div>*/}
                      </div>
                      :
                      <span></span>
              }
              
          </div>
      </div>
  )
};
const mstp = state => ({
    paymentToken: state.paymentToken,
    otpErr: state.otpErr
});
export default connect (mstp)(Confirmation);